import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';
const base = require("../../assets/js/gamedefault");

Vue.prototype.axios = axios;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8;'; //设置文本提交类型

// const baseServer = "http://143.92.56.219:13939//user/";

// const searchServer = "http://143.92.56.219:13939/";

// http://143.92.56.219:13939/

const baseServer = "https://sjsj.9d9d.vip/user/";

const searchServer = "https://sjsj.9d9d.vip/";

const postRouteAliasMap = {
    actionlog: "Log/action",
    audioswitch: "account/audioswitch",
    bet: "bet/bet2",
    bet2: "bet/bet2",
    betlog: "Log/bet",
    chearBetList: "bet/clearBetList",
    chargeback: "bet/chargeback",
    chargebackForOrderid: "bet/chargebackForOrderid",
    creditsinfo: "account/creditsinfo",
    currentissuebetlist: "bet/currentissuebetlist",
    gameinfo: "game/gameinfo",
    gamelist:"game/gamelist",
    introduction: "game/introduction",
    issuereport: "report/issuereport",
    dayReport: "report/dayReport",
    kuaidaodds: "bet/kuaidaodds",
    newpwd: "auth/resetPwd",
    notice: "account/notice",
    openinfo: "game/openinfo",
    report: "report/report",
    setskin: "account/setskin",
    speedList: "auth/speedList",
    userinfo: "account/userinfo"
};

const normalizePostApiPath = (url) => {
    const cleanUrl = String(url || "").replace(/^\/+/, "");
    return postRouteAliasMap[cleanUrl] || cleanUrl;
};

let loading_hide = function(){
    $("#myLayerImg").remove();
    $("#mymask").remove();
}
//获取数据库表中信息
const getAxiosMethod = (URL, obj, suc) => {

    axios.get(searchServer + URL, {
        params: obj
    }).then((res) => {
        suc(res);
    }).catch((e) => {
        console.log(e);
    });
}

//获取数据库表中信息
const search = (URL, obj, suc) => {

    axios.post(searchServer + URL, qs.stringify(obj)).then((res) => {
        suc(res);
    }).catch((e) => {
        console.log(e);
    });
}

//提交客户端数据信息到数据库
const postAxiosMethod = (URL, args, suc) => {
    URL = normalizePostApiPath(URL);
    if(args){
        args.token = sessionStorage.getItem("token")
    }
    const user_token = window.sessionStorage.getItem("login")
    if(user_token){
      let user_token_arr =user_token.split("&")
      args.access_token =user_token_arr[0]
      args.uid = user_token_arr[1]
    }
    let data = qs.stringify(args);
    axios.post(baseServer + URL, data)
        .then(function (res) {
            if (res.data.code < 0) {
                if (res.data.code == -104) {
                    suc(res);
                }else if(res.data.code == -105){
                    suc(res);
                } else if (res.data.code == -1001) {
                    base.G.alert({
                        content: res.data.msg,
                        ok: function () {
                            window.location.href = "/";
                            return true;
                        }, type: '1' });
                    window.sessionStorage.setItem("login", "");
                } else if (res.data.code == -102) {
                    base.G.alert({ content: res.data.msg, ok: function () { return true; }, type: '1' });
                } else {

                    base.G.alert({
                        content: res.data.msg,
                        ok: function () {
                            return true;
                        },
                        type: "1"
                    });
                }
            }else if(res.data.code == 500){
                base.G.alert({
                    content: "系统错误",
                    ok: function () {
                        return true;
                    },
                    type: "1"
                });
            } else {
                suc(res);
            }
            $("#myLayerImg").remove();
            $("#mymask").remove();
        }).catch(function (e) {
            console.log(e)
            // base.G.alert({ content: e, ok: function () { return true; }, type: '1' });
            // $("#myLayerImg").remove();
            // $("#mymask").remove();
        });
}

const customAxios = (URL, args) => {
    return axios.post(baseServer + URL, args)
            .then(function (res) {
                return res.data
            }).catch(err => {
                console.log('error:' + error);
            })
}



export default {
    customAxios,
    search,
    getAxiosMethod,
    postAxiosMethod
}
